import React from "react";

interface ProductCodeSelectionProps {
  value: string;
  onChange: (val: "C" | "E") => void;
  disabled?: boolean;
}

export const ProductCodeSelection: React.FC<ProductCodeSelectionProps> = ({
  value = "C",
  onChange,
  disabled = false,
}) => {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value as "C" | "E")}
      disabled={disabled}
      className="mantine-input ce-select"
      style={{ width: 128, height: 32 }}
    >
      <option value="C">C</option>
      <option value="E">E</option>
    </select>
  );
};
